import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { openPrintPage } from '../../../Helpers/PrintHelper';
import styles from './PrintLink.module.css';

export default function PrintLink({ onClick }) {
    const vizDataByTab = useSelector(state => state.features.vizDataByTab);
    const exteriorAppliedProducts = useSelector(state => state.features.exteriorAppliedProducts);
    const kitchenAppliedProducts = useSelector(state => state.features.kitchenAppliedProducts);
    const floorPlanInfo = useSelector(state => state.features.floorPlanInfo);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }

        openPrintPage(vizDataByTab, exteriorAppliedProducts, kitchenAppliedProducts, floorPlanInfo);
    };

    return (
        <button className={styles.viewBtn} onClick={handleClick}>
            Print
        </button>
    );
}

PrintLink.propTypes = {
    onClick: PropTypes.func,
};
